<template>
    <div>
        <!-- 点击登录 -->
        <Navigation class="canNotSelectCss"></Navigation>
        <!-- 横幅 -->
        <Banner></Banner>
        <!-- 我要融资 我要投资 -->
        <FunctionButtons></FunctionButtons>
        <!-- 政务要闻 -->
        <GovernmentNews></GovernmentNews>
        <!-- 平台特色 -->
        <AreaDataImg></AreaDataImg>
        <!-- 场景金融 -->
        <PlatformTarget></PlatformTarget>
        <!-- 贷款问答 -->
        <LoanInterlocution></LoanInterlocution>
        <!-- 关于我们 -->
        <PlatformInfo class="canNotSelectCss"></PlatformInfo>
        <!-- 底部版权 -->
        <CompanyInfo class="canNotSelectCss"></CompanyInfo>
    </div>
</template>

<script>

import Banner from '../components/Department_Industry_Finance/Banner.vue'
import Navigation from '../components/Department_Industry_Finance/Navigation.vue';
import PlatformInfo from '../components/Department_Industry_Finance/PlatformInfo.vue';
import CompanyInfo from '../components/Department_Industry_Finance/CompanyInfo.vue';
import GovernmentNews from '../components/Department_Industry_Finance/GovernmentNews.vue'
import PlatformTarget from '../components/Department_Industry_Finance/PlatformTarget.vue'
import FunctionButtons from '../components/Department_Industry_Finance/FunctionButtons.vue'
import LoanInterlocution from '../components/LoanInterlocution.vue'
import AreaDataImg from '../components/Department_Industry_Finance/AreaDataImg.vue'

export default {
    name: "Home",
    components: {
        Navigation,
        CompanyInfo,
        PlatformInfo,
        GovernmentNews,
        Banner,
        PlatformTarget,
        FunctionButtons,
        LoanInterlocution,
        AreaDataImg,
    },
}
</script>
<style>
/* 字体不可选择 */
.canNotSelectCss {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue